// extracted by mini-css-extract-plugin
export var pageHeader = "RDykbcRced4kGYjaYRyq";
export var pageHeaderTitle = "Z4MaRqhvOhrLbotOW6k3";
export var pageHeaderValue = "Ptj8CZBkoMiu6Bt0uD9m";
export var skeleton = "Mb7SdJ9sTbQhGpRqYTC_";